export const residentPlatformName = 'Домучёт';

export const managementCompany = {
  legalName: 'ООО «ЛД-Сервис»',
  displayName: 'ЛД-Сервис',
  fee: {
    amountRub: 9_000,
    label: '9 000 ₽',
    period: 'в квартал',
  },
} as const;
